import React from 'react';
import { ToastButton } from '../components/Toast';
import intercomFacade from '../utils/intercomFacade';

interface ContactSupportButtonProps {
  onDismiss: () => void;
}

const ContactSupportButton = ({ onDismiss }: ContactSupportButtonProps) => {
  const isIntercomDisabled = intercomFacade.hasError;

  if (isIntercomDisabled) {
    return (
      <ToastButton to="https://go.slab.com/slab-contact-us">
        Contact support
      </ToastButton>
    );
  }

  return (
    <ToastButton
      onClick={() => {
        window.Intercom?.('show');
        onDismiss();
      }}
    >
      Contact support
    </ToastButton>
  );
};

export default ContactSupportButton;
